import { getToken } from "../utils/utilFunctions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const headers = () => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${getToken()}`,
});

export async function fetchProjectTemplates() {
    const res = await fetch(`${API_URL}/api/projects/templates`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function fetchProjects() {
    const res = await fetch(`${API_URL}/api/projects/`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function fetchFullProjects() {
    const res = await fetch(`${API_URL}/api/projects/full`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function fetchProjectById(id) {
    const res = await fetch(`${API_URL}/api/projects/?id=${id}`, {
        method: "GET",
        headers: headers(),
    });

    const data = await res.json();

    if (!res.ok || !data.success) {
        throw new Error(data.message);
    }

    return data.data;
}

export async function createProject(projectData) {
    const res = await fetch(`${API_URL}/api/projects`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(projectData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function createProjectPhase(phaseData) {
    const res = await fetch(`${API_URL}/api/projects/phases`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(phaseData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function createProjectCategory(categoryData) {
    const res = await fetch(`${API_URL}/api/projects/categories`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(categoryData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function deleteProjectPhase(id) {
    const res = await fetch(`${API_URL}/api/projects/phases/${id}`, {
        method: "DELETE",
        headers: headers(),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data;
}

export async function deleteProjectCategory(id) {
    const res = await fetch(`${API_URL}/api/projects/categories/${id}`, {
        method: "DELETE",
        headers: headers(),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data;
}

export async function updateProjectPhase(id, phaseData) {
    const res = await fetch(`${API_URL}/api/projects/phases/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(phaseData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function updateProjectCategory(id, categoryData) {
    const res = await fetch(`${API_URL}/api/projects/categories/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(categoryData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function createProjectTask(taskData) {
    const res = await fetch(`${API_URL}/api/projects/tasks`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(taskData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function deleteProjectTask(id) {
    const res = await fetch(`${API_URL}/api/projects/tasks/${id}`, {
        method: "DELETE",
        headers: headers(),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data;
}

export async function updateProjectTask(id, taskData) {
    const res = await fetch(`${API_URL}/api/projects/tasks/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(taskData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function cloneProject(originalProjectId, title, amount) {
    const res = await fetch(`${API_URL}/api/projects/clone`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify({
            originalProjectId,
            title,
            amount
        }),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function updateProjectApi(id, projectData) {
    const res = await fetch(`${API_URL}/api/projects/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(projectData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function createCompany(companyData) {
    const res = await fetch(`${API_URL}/api/companies`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(companyData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function updateCompany(id, companyData) {
    const res = await fetch(`${API_URL}/api/companies/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(companyData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function fetchProjectCompanies() {
    const res = await fetch(`${API_URL}/api/projects/companies`, {
        method: "GET",
        headers: headers(),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function createProjectCompany(companyData) {
    const res = await fetch(`${API_URL}/api/projects/companies`, {
        method: "POST",
        headers: headers(),
        body: JSON.stringify(companyData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}

export async function updateProjectCompany(id, companyData) {
    const res = await fetch(`${API_URL}/api/projects/companies/${id}`, {
        method: "PUT",
        headers: headers(),
        body: JSON.stringify(companyData),
    });

    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.message);
    return data.data;
}